'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.demand_histogram', {
        template: '<demand-histogram></demand-histogram>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/histogram/demand_histogram.routes.js